import * as React from "react";
const SvgSandwichArtist = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 49, height: 51, viewBox: "0 0 49 51", fill: "none", ...props }, "...");
export default SvgSandwichArtist;
